import { Component, OnInit } from '@angular/core';
import { ContextService } from '@core/services/core/context.service';
import { NavigationHelper } from '@core/services/core/navigation-helper.service';
import { OperationRegisterService } from '@core/services/core/operation-register.service';
import { RgpdueRights } from '@models/operation-register';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-rgpdue-rights-protection-detail',
  templateUrl: './rgpdue-rights-protection-detail.component.html',
  styleUrls: ['./rgpdue-rights-protection-detail.component.scss']
})
export class RgpdueRightsProtectionDetailComponent implements OnInit {
  rightsProtectionSubtitle2: string;
  constructor(
    public ctx: ContextService,
    private trans: TranslateService,
    private or: OperationRegisterService,
    private nav: NavigationHelper
  ) {}

  ngOnInit() {
    this.rightsProtectionSubtitle2 = this.trans.instant(
      'PROFILE.RGPD_RIGHTS.RIGHTS_PROTECTION_SUBTITLE2'
    );
  }

  onExerciseRights() {
    this.or.registerRGPDUERights({ operationCode: RgpdueRights.HOME });
    this.nav.to('operations/rgpdue-rights-select-option');
  }
}
